import { Component, OnInit, ViewChild } from '@angular/core';
import { HttpService } from 'app/services/http.service';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { sortBy } from 'lodash-es';
import { compare } from 'compare-versions';

@Component({
  selector: 'app-versions',
  templateUrl: './versions.component.html',
  styleUrls: ['./versions.component.scss'],
})
export class VersionsComponent implements OnInit {
    @ViewChild('versionDialog') versionDialog: any;

  loading = true;
  versionForm: FormGroup;
  versions: any = [];
  tableRows: any = [];
  selectedVersion: any;
  list: any;
  dialogRef: MatDialogRef<VersionsComponent>;
  displayedColumns: any = [
    { key: 'name', label: 'Name', type: 'string' },
    { key: 'mandatory', label: 'Mandatory Version', type: 'string' },
    { key: 'optional', label: 'Optional Version', type: 'string' },
    { key: 'created', label: 'Modified Date', type: 'date' },
    { key: 'modifiedBy', label: 'Modified By', type: 'string' },
  ];
  waltOtaKey = 'walt-ota-s';
  waltOta5gKey = 'walt-ota-5g';
  constructor(private readonly _httpService: HttpService, private readonly _dialog: MatDialog, private readonly _formBuilder: FormBuilder) { }

  ngOnInit(): void {
    this.load();
  }

  async editVersion(id: number) {
    this.selectedVersion = this.versions.find(x => x.id === id);
    this.list = [{ 'key': '' }].concat(this.selectedVersion.list);

    this.versionForm = this.buildForm(this.selectedVersion);
    this.dialogRef = this._dialog.open(this.versionDialog);
  }

  async load() {
    this.loading = true;
    this.versions = await this._httpService.get('administration/versions');

    this.versions = sortBy(this.versions, 'id');
    const acceptedVersions = new Set<string>(['ios', 'android', 'walt-ota-s', 'walt-ota-5g']);
    this.versions = this.versions.filter(x => acceptedVersions.has(x.id));
    this.tableRows = this.versions.map(x => {
        if (x.id === this.waltOtaKey) {
            return {
                ...x,
                name: 'Walt 4G',
            };
        } else if (x.id === this.waltOta5gKey) {
            return {
                ...x,
                name: 'Walt 5G',
            };
        } else {
            return { ...x,
                name: x.id,
             };
        }
    });
    this.loading = false;
  }

  async submit() {
    await this._httpService.put('administration/versions', this.versionForm.value);
    this.load();
    this.dialogRef.close();
  }

  buildForm(data: any) {
    const formGroup = this._formBuilder.group({
        id: new FormControl(data.id),
        type: new FormControl(data.type),
        prefix: new FormControl(data.prefix),
        mandatory: new FormControl(data.mandatory),
        optional: new FormControl(data.optional),
    });

    return formGroup;
  }

  getLessThanVersionNumber(value: string, strippedOtaVersionNumbers: string[], versions: any) {
    const lessThanVersions = this.getVersionsLessThanEqualTo(strippedOtaVersionNumbers, value.match(/[0-9]+/g).join('.'));
    const foundVersion = versions.find(x => { return x.key.includes(lessThanVersions[0]); });
    return foundVersion;
  }

  getStrippedVersionNumbers(arr) {
    arr = arr.filter(x => { return x.key !== ''; });
    return arr.map(function (item) {
        const parts = item.key.match(/[0-9]+/g);
        return parts.join('.');
    });
  }

  getVersionsLessThanEqualTo(arr, n) {
    return arr.filter(i => compare(i, n, '<='));
  }
}
